import { Popover } from 'antd';
import type { ReactNode } from 'react';

import { InfoCircleOutlined } from '@ant-design/icons';

export const InfoPopover = ({ title, content, info }: { title: ReactNode; content: ReactNode; info?: boolean }) => {
  return (
    <span className={info ? 'infoTitle' : ''}>
      {title}
      <Popover
        rootClassName="dashboardPopover"
        color="#3a4454"
        content={content}
        arrow={{ pointAtCenter: true }}
        trigger="hover"
        placement="right"
      >
        <InfoCircleOutlined className="infoCircleText" />
      </Popover>
    </span>
  );
};
